module.exports = __webpack_public_path__ + "skill-c4e07b8b/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";